import React from 'react';
import { Field } from 'redux-form';
import UploadFile from './UploadFile';
import styles from './DetailForm.css';

export const residenceOwnership = [
  { name: 'Milik Sendiri', value: 'MILIK_SENDIRI' },
  { name: 'Keluarga', value: 'KELUARGA' },
  { name: 'Rumah Dinas', value: 'RUMAH_DINAS' },
  { name: 'Sewa', value: 'SEWA' },
  { name: 'Kos', value: 'KOS' },
];

export const listOfBank = [
  { name: 'Bank Central Asia (BCA)' },
  { name: 'Bank Rakyat Indonesia (BRI)' },
  { name: 'Bank Mandiri' },
  { name: 'Bank Negara Indonesia (BNI)' },
  { name: 'Bank CIMB Niaga' },
  { name: 'Bank Tabungan Negara (BTN)' },
  { name: 'Bank Panin' },
  { name: 'Bank Permata' },
  { name: 'Bank Maybank Indonesia' },
  { name: 'Bank Danamon' },
  { name: 'Other' },
];
export const maritalStatus = [
  { name: 'Single', value: 'SINGLE' },
  { name: 'Married', value: 'MARRIED' },
  { name: 'Divorced', value: 'DIVORCED' },
];

export const relationshipStatus = [
  { name: 'Spouse', value: 'SPOUSE' },
  { name: 'Parent', value: 'PARENT' },
  { name: 'Relative', value: 'RELATIVE' },
  { name: 'Sibling', value: 'SIBLING' },
];

export const gender = [
  { name: 'Male', value: 'M' },
  { name: 'Female', value: 'F' },
];

export const Months = [
  { name: 'January', value: 1 },
  { name: 'February', value: 2 },
  { name: 'March', value: 3 },
  { name: 'April', value: 4 },
  { name: 'May', value: 5 },
  { name: 'June', value: 6 },
  { name: 'July', value: 7 },
  { name: 'August', value: 8 },
  { name: 'September', value: 9 },
  { name: 'October', value: 10 },
  { name: 'November', value: 11 },
  { name: 'December', value: 12 },
];

export const OwnerStatus = [
  { name: 'Pemilik', value: 'Pemilik' },
  { name: 'Pemegang Saham', value: 'Pemegang Saham' },
  { name: 'Karyawan', value: 'Karyawan' },
];

export const MostTransactionType = [
  { name: 'Tunai', value: 'Tunai' },
  { name: 'Kartu Debit', value: 'Kartu Debit' },
  { name: 'Kartu Kredit', value: 'Kartu Kredit' },
  { name: 'Lainnya', value: 'Lainnya' },
];

export const CompanyType = [
  { name: 'Perorangan', value: 'Perorangan' },
  { name: 'UD', value: 'UD' },
  { name: 'CV', value: 'CV' },
  { name: 'PT', value: 'PT' },
];

export const numberOnly = () => (value, previousValue) => {
  if (value) {
    if (isNaN(value) || value.includes('.')) {
      return previousValue;
    }
  }
  return value;
};

export const alphaNumeric = () => (value, previousValue) => {
  if (value) {
    if (!/^([a-zA-Z0-9 ])*$/g.test(value)) {
      return previousValue;
    }
  }
  return value;
};

export const alphabeticalOnly = () => (value, previousValue) => {
  if (value) {
    if (!/^([a-zA-Z ])*$/g.test(value)) {
      return previousValue;
    }
  }
  return value;
};
export const alphabeticalAndSomeChar = () => (value, previousValue) => {
  if (value) {
    const regex = /^([a-zA-Z0-9,. ()-])*$/g;
    if (!regex.test(value)) {
      return previousValue;
    }
  }
  return value;
};

export const inputField = field => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        placeholder={field.placeholder}
        className={field.className}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

export const textAreaField = field => {
  return (
    <div>
      <textarea
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        placeholder={field.placeholder}
        className={field.className}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

export const renderSelectField = ({
  input,
  meta: { touched, error },
  children,
  className,
}) => (
  <div>
    <div className={styles.tooltip}>
      <select
        {...input}
        className={`${className} ${
          touched && error ? styles['red-border'] : ''
        }`}
      >
        {children}
      </select>
      {touched && error && (
        <small className={styles.error}>{touched ? error : ''}</small>
      )}
    </div>
  </div>
);

export const BankStatemnetArray = ({ fields }) => {
  return (
    <div>
      {fields.map((member, index) => {
        return (
          <div key={index}>
            <Field
              type="file"
              name={`${member}.bank_statement`}
              component={UploadFile}
              className={`${styles['form-control-file']}`}
              allowPDF
              indexFile={index}
              fields={fields}
            />
          </div>
        );
      })}
      <a
        className={`${styles['add-file']}`}
        onClick={() => {
          if (fields.length < 3) fields.push({ code: '', name: '' });
        }}
      >
        Add More
      </a>
    </div>
  );
};
export const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <small className={styles.error}>{touched ? error : ''}</small>
  ) : (
    false
  );

export function deformatCurrency(str) {
  function removeComma(str) {
    str = str.replace(',', '');
    if (str.indexOf(',') >= 0) return removeComma(str);
    return str;
  }
  str = removeComma(str);
  return str.split('.').join('');
}

export function formatCurrency(str) {
  const currencyWithoutDot = deformatCurrency(str);
  let result = '';
  for (let i = 1; i <= currencyWithoutDot.length; i++) {
    result = currencyWithoutDot[currencyWithoutDot.length - i] + result;
    if (i % 3 === 0) result = `.${result}`;
  }

  // clean last dot in the last char
  if (result[0] === '.') return result.slice(1);
  return result;
}
